const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api";

const CATEGORIES = {
  GET_CATEGORIES: `${API_BASE_URL}/categories/categories/`,
  ALL_SERVICE_PROVIDERS: `${API_BASE_URL}/categories/services-landing/`,
  SEARCH: `${API_BASE_URL}/categories/search-services/`,
};

export default CATEGORIES;